<section [formGroup]="form">
    @if (canHaveField('siteStatus')) {
        <div class="w-full max-w-[400px]">
            <app-application-form-field
                label="Site Status"
                [tooltipMessage]="messages.siteStatusTooltip"
                [dialogTooltip]="true"
                dialogTooltipTitle="Site Status"
                [inline]="true"
                [showTooltipIcon]="true"
            >
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    color="primary"
                >
                    <mat-label>Site Status</mat-label>
                    <mat-select formControlName="siteStatus" #siteStatusField>
                        @for (option of siteStatusOptions; track option.value) {
                            <mat-option [value]="option.value">{{
                                option.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
        </div>
    }

    @if (canHaveField('nepa')) {
        <div class="flex flex-row space-x-5">
            <div class="w-full max-w-[400px]">
                <app-application-form-field
                    label="NEPA Required?"
                    [tooltipMessage]="messages.nepaTooltip"
                    [dialogTooltip]="true"
                    dialogTooltipTitle="NEPA Required?"
                    [inline]="true"
                    [showTooltipIcon]="true"
                >
                    <mat-form-field
                        appearance="outline"
                        class="w-full"
                        color="primary"
                    >
                        <mat-label>NEPA Required?</mat-label>
                        <mat-select formControlName="nepa">
                            @for (option of nepaOptions; track option.value) {
                                <mat-option [value]="option.value">{{
                                    option.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
            </div>
            @if (form.controls.nepa.value) {
                <app-attachment-required-button class="w-60" />
            }
        </div>
    }

    @if (canHaveField('clearanceIndicator')) {
        <div class="w-full max-w-[400px]">
            <app-application-form-field
                label="Frequency Coordination in Canada?"
                [tooltipMessage]="messages.clearanceIndicatorTooltip"
                [dialogTooltip]="true"
                dialogTooltipTitle="Frequency Coordination in Canada?"
                [inline]="true"
                [showTooltipIcon]="true"
            >
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    color="primary"
                >
                    <mat-label>Frequency Coordination in Canada?</mat-label>
                    <mat-select formControlName="clearanceIndicator">
                        @for (
                            option of clearanceIndicatorOptions;
                            track option.value
                        ) {
                            <mat-option [value]="option.value">{{
                                option.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
        </div>
    }

    @if (canHaveField('quietZoneNotificationDate')) {
        <mat-form-field class="w-full max-w-[400px]">
            <input
                placeholder="Quiet Zone, Date of Proper Notification"
                matInput
                [matDatepicker]="picker"
                formControlName="quietZoneNotificationDate"
            />
            <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    }

    @if (canHaveField('quietZoneConsent')) {
        <div class="w-full max-w-[400px]">
            <app-application-form-field
                label="Prior Written Consent From Quiet Zone entity?"
                [tooltipMessage]="messages.quietZoneConsentTooltip"
                [dialogTooltip]="true"
                dialogTooltipTitle="Prior Written Consent From Quiet Zone entity?"
                [inline]="true"
                [showTooltipIcon]="true"
            >
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    color="primary"
                >
                    <mat-label
                        >Prior Written Consent From Quiet Zone
                        entity?</mat-label
                    >
                    <mat-select formControlName="quietZoneConsent">
                        @for (
                            option of quietZoneConsentOptions;
                            track option.value
                        ) {
                            <mat-option [value]="option.value">{{
                                option.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
        </div>
    }

    @if (canHaveField('mexicoClearanceIndicator')) {
        <div class="w-full max-w-[400px]">
            <app-application-form-field
                label="Requires Coordination With Mexico?"
                [tooltipMessage]="messages.mexicoClearanceIndicatorTooltip"
                [dialogTooltip]="true"
                dialogTooltipTitle="Requires Coordination With Mexico?"
                [inline]="true"
                [showTooltipIcon]="true"
            >
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    color="primary"
                >
                    <mat-label>Requires Coordination With Mexico?</mat-label>
                    <mat-select formControlName="mexicoClearanceIndicator">
                        @for (
                            option of mexicoClearanceIndicatorOptions;
                            track option.value
                        ) {
                            <mat-option [value]="option.value">{{
                                option.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
        </div>
    }
</section>
